import { useAuth0 } from '@auth0/auth0-react';
import { FC, ReactNode, useEffect } from 'react';
import { useUserContext } from './UserProvider';

const AuthProviderWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();
  const { setUser, setConnection } = useUserContext();
  useEffect(() => {
    if (isAuthenticated && user) {
      getAccessTokenSilently().then((token) => {
        // Check if user.sub is defined
        if (user.sub) {
          setConnection(user.sub);
        }

        setUser(token);
      });
    }
  }, [isAuthenticated, getAccessTokenSilently, user]);
  return <div>{children}</div>;
};

export default AuthProviderWrapper;
